import { FC, useMemo } from 'react';
import { Range } from 'react-range';
import styles from './styles.module.scss';
import classNames from 'classnames/bind';
import { Icon } from '@components/icons';

interface IProps {
    value: number;
    onChange: (value: number) => void;
    min: number;
    max: number;
    step?: number;
}

const cx = classNames.bind(styles);

const BarPicker: FC<IProps> = ({ onChange, value, min, max, step = 1 }) => {
    const getProgressStyle = useMemo(() => {
        const firstPoint = value / (max / 100);
        return {
            background: `linear-gradient(to right, var(--primary-40) 0%, var(--primary-40) ${firstPoint}%, var(--primary-80) ${firstPoint}%, var(--primary-80) 100%)`
        };
    }, [value]);

    return (
        <div className={styles.main_wrapper}>
            <button onClick={() => onChange(value - step)}>
                <Icon name="outlined_minus" />
            </button>
            <Range
                step={step}
                min={min}
                max={max}
                values={[value]}
                onChange={(val) => onChange(val[0])}
                renderTrack={({ props, children }) => {
                    return (
                        <div className={styles.wrapper} {...props} style={getProgressStyle}>
                            {children}
                        </div>
                    );
                }}
                renderThumb={({ props, isDragged, value }) => {
                    return <div {...props} className={cx([styles.point])} />;
                }}
            />
            <button onClick={() => onChange(value + step)}>
                <Icon name="outlined_plus" />
            </button>
        </div>
    );
};

export default BarPicker;
